import { connect } from 'react-redux';
import Stats from '../../../components/DailyPlanning/Stats/Stats';

const mapStateToProps = ({ entities: { postings, treatmentInstances } }) => ({
  availableHours: postings.general.availableTime,
  allocatedHours: postings.general.assignedTime,
  allocatedHoursForAssignments: postings.general.assignedTimeForAssignments,
  allocatedHoursForNonPatientAssignments: postings.general.assignedTimeForNonPatientAssignments,
  unallocatedHours: treatmentInstances.general.unallocatedTime,
});

const StatsWithHours = connect(mapStateToProps)(Stats);

export default StatsWithHours;
